<!--<mat-card appCard style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2)">-->
<!--    &lt;!&ndash; <mat-card-header>-->
<!--        <app-card-title>{{ "general_information" | translate }}</app-card-title>-->
<!--    </mat-card-header> &ndash;&gt;-->
<!--    <mat-card-content class="card-content">-->

<!--        <table class="table table-bordered">-->
<!--            <colgroup>-->
<!--                <col style="width: 20%">-->
<!--                <col style="width: 40%">-->
<!--                <col style="width: 20%">-->
<!--                <col style="width: 20%">-->
<!--            </colgroup>-->
<!--            <tbody>-->
<!--            <tr>-->
<!--                <th class="table-active"> {{ "title1" | translate }}</th>-->
<!--                <td colspan="3">-->

<!--                    <span *ngIf="current_lang=='ar'"> {{item.title2}}</span>-->
<!--                    <span *ngIf="current_lang=='fr'"> {{item.title1}}</span>-->
<!--                    <span *ngIf="current_lang=='en'"> {{item.titleEn}}</span>-->

<!--                </td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--                <th class="table-active">{{ "lawClCd" | translate }}</th>-->
<!--                <td> {{getlabel(item.lawClCd)|translate}}</td>-->
<!--                <th class="table-active">{{ "modDt" | translate }}</th>-->
<!--                <td>{{item.modDt | date : 'dd/MM/yyyy' }}</td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--                <th class="table-active">{{ "moderNm" | translate }}</th>-->
<!--                <td>{{item.moderNm}}</td>-->
<!--                <th class="table-active">{{ "hitCnt" | translate }}</th>-->
<!--                <td>{{item.hitCnt}}</td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--                <th class="table-active">{{ "Contenus" | translate }}</th>-->
<!--                <td colspan="3" style="vertical-align:top;">-->
<!--                    &lt;!&ndash;   {{item.cont1}} &ndash;&gt;-->


<!--                    <div #frContainer></div>-->
<!--                </td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--                <th class="table-active">{{"Fichiers attachés"|translate}}</th>-->
<!--                <td colspan="3" *ngIf="fileitems">-->

<!--                    <a *ngFor="let fileitem of fileitems" style="color: blue;"-->
<!--                       (click)="downloadFile(fileitem.nodeRef, fileitem.originFileNm, fileitem.fileUrl)">-->
<!--                        {{fileitem?.originFileNm}} &nbsp;({{fileitem?.fileSize}} KB)-->
<!--                        <br>-->
<!--                    </a>-->


<!--                </td>-->
<!--            </tr>-->
<!--            </tbody>-->
<!--        </table>-->

<!--        <div align="right" *ngIf="current_lang=='fr'|| current_lang=='en'">-->
<!--            <div *ngIf="item.lawClCd=='A'">-->
<!--                <button [routerLink]="['/portail/cmis_Lois/']" mat-raised-button-->
<!--                        style="background-color:#3E90D0; color: white;">{{"Liste"|translate}}</button>-->
<!--            </div>-->
<!--            <div *ngIf="item.lawClCd=='B'">-->
<!--                <button [routerLink]="['/portail/cmis_Decrets/']" mat-raised-button-->
<!--                        style="background-color:#3E90D0; color: white;">{{"Liste"|translate}}</button>-->
<!--            </div>-->
<!--            <div *ngIf="item.lawClCd=='C'">-->
<!--                <button [routerLink]="['/portail/cmis_Arretes/']" mat-raised-button-->
<!--                        style="background-color:#3E90D0; color: white;">{{"Liste"|translate}}</button>-->
<!--            </div>-->
<!--            <div *ngIf="item.lawClCd=='E'">-->
<!--                <button [routerLink]="['/portail/cmis_manuel/']" mat-raised-button-->
<!--                        style="background-color:#3E90D0; color: white;">{{"Liste"|translate}}</button>-->
<!--            </div>-->
<!--            <div *ngIf="item.lawClCd=='Z'">-->
<!--                <button [routerLink]="['/portail/cmis_Autres/']" mat-raised-button-->
<!--                        style="background-color:#3E90D0; color: white;">{{"Liste"|translate}}</button>-->
<!--            </div>-->
<!--        </div>-->

<!--        <div style="float: left;" *ngIf="current_lang=='ar'">-->
<!--            <div *ngIf="item.lawClCd=='A'">-->
<!--                <button [routerLink]="['/portail/cmis_Lois/']" mat-raised-button-->
<!--                        style="background-color:#3E90D0; color: white;">{{"Liste"|translate}}</button>-->
<!--            </div>-->
<!--            <div *ngIf="item.lawClCd=='B'">-->
<!--                <button [routerLink]="['/portail/cmis_Decrets/']" mat-raised-button-->
<!--                        style="background-color:#3E90D0; color: white;">{{"Liste"|translate}}</button>-->
<!--            </div>-->
<!--            <div *ngIf="item.lawClCd=='C'">-->
<!--                <button [routerLink]="['/portail/cmis_Arretes/']" mat-raised-button-->
<!--                        style="background-color:#3E90D0; color: white;">{{"Liste"|translate}}</button>-->
<!--            </div>-->
<!--            <div *ngIf="item.lawClCd=='E'">-->
<!--                <button [routerLink]="['/portail/cmis_manuel/']" mat-raised-button-->
<!--                        style="background-color:#3E90D0; color: white;">{{"Liste"|translate}}</button>-->
<!--            </div>-->
<!--            <div *ngIf="item.lawClCd=='Z'">-->
<!--                <button [routerLink]="['/portail/cmis_Autres/']" mat-raised-button-->
<!--                        style="background-color:#3E90D0; color: white;">{{"Liste"|translate}}</button>-->
<!--            </div>-->
<!--        </div>-->

<!--    </mat-card-content>-->
<!--</mat-card>-->


<!--<div *ngIf="item">-->
<ng-container>
    <app-fiche-consultation (openDialogListFilesEvent)="openDialogListAttachFiles({code: (cardDetailCMIS['ref'] + 'AttachFiles'), element: item})"
                            [dataColumnsAr]="cardDetailCMIS['displayedColumns']['ar']"
                            [dataColumnsEn]="cardDetailCMIS['displayedColumns']['en']"
                            [dataColumns]="cardDetailCMIS['displayedColumns']['fr']"
                            [data]="[item || {}]"
                            [inputData]="{isDetailsAnnoncesServices: true, Cont: 5, Att: 6}"
                            [label]="_getlabel(item?.lawClCd)"
                            [labels]="cardDetailCMIS['labels']"
                            [langue]="translate.getDefaultLang()"
    >
        <div class="pt-2" contentTemplate>
            <div #contentContainer></div>
        </div>
    </app-fiche-consultation>
    <!--</div>-->
    <div class="mt-2" fxLayout="row wrap" fxLayoutAlign="end center">
        <button (click)="onPrecedent()" mat-raised-button
                style="background-color:#3E90D0; color: white;">{{"Liste"|translate}}</button>
    </div>

</ng-container>
<app-spinner-container [isLoading]="item == undefined || item == null">
</app-spinner-container>
